

export const CellType = {
  Text: 'text',
  Field: 'field',
  Button: 'button'
}